import React from "react";
import { sanitize } from "dompurify";

const StaticHTML = ({ content }) => {
  const createMarkup = () => ({ __html: sanitize(content) });

  return (
    // eslint-disable-next-line
    <div dangerouslySetInnerHTML={createMarkup()} />
  );
};

export default StaticHTML;



// WEBPACK FOOTER //
// ./src/components/StaticHTML/StaticHTML.tsx